import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Checkbox from '@material-ui/core/Checkbox';
import TableSortLabel from '@material-ui/core/TableSortLabel';

import { allColumns } from './MatTable';

class MatTableHead extends PureComponent {
  static propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
    visibleColumns: PropTypes.array.isRequired,
  };

  createSortHandler = property => (event) => {
    const { onRequestSort } = this.props;
    onRequestSort(event, property);
  };

  render() {
    const {
      onSelectAllClick, order, orderBy, numSelected, rowCount, visibleColumns
    } = this.props;

    // Build rows from allColumns filtered by visibleColumns, excluding address (rendered in frozen cell)
    const rows = allColumns.filter(col => visibleColumns.includes(col.id) && col.id !== 'display_full_street_address');

    return (
      <TableHead>
        <TableRow>
          {/* Frozen: checkbox + Address label in one cell */}
          <TableCell className="ps-table__cell--frozen" padding="none">
            <div className="ps-table__frozen-content">
              <div className="ps-table__checkbox">
                <Checkbox
                  className={`material-table__checkbox ${numSelected === rowCount && rowCount > 0 && 'material-table__checkbox--checked'}`}
                  indeterminate={numSelected > 0 && numSelected < rowCount}
                  checked={numSelected === rowCount && rowCount > 0}
                  onChange={onSelectAllClick}
                />
              </div>
              <TableSortLabel
                active={orderBy === 'display_full_street_address'}
                direction={order}
                onClick={this.createSortHandler('display_full_street_address')}
                className="material-table__sort-label"
                dir="ltr"
              >
                Address
              </TableSortLabel>
            </div>
          </TableCell>
          {rows.map(row => (
            <TableCell
              className="material-table__cell material-table__cell--sort material-table__cell-right ps-table__cell--scroll"
              key={row.id}
              align="left"
              padding={row.disablePadding ? 'none' : 'default'}
              sortDirection={orderBy === row.id ? order : false}
            >
              {row.disableSort ?
                <span className="material-table__sort-label">{row.label}</span>
                :
                <TableSortLabel
                  active={orderBy === row.id}
                  direction={order}
                  onClick={this.createSortHandler(row.id)}
                  className="material-table__sort-label"
                  dir="ltr"
                >
                  {row.label}
                </TableSortLabel>
              }
            </TableCell>
          ), this)}
        </TableRow>
      </TableHead>
    );
  }
}

export default connect(state => ({
  user: state.user
}))(MatTableHead);
